<template>
  <!-- eslint-disable-next-line vue/no-v-html -->
  <span v-html="genHTML" />
</template>
<script>
  import { pregQuote, xss } from '../../utils/util';

  export default {
    name: 'ZmHighlightText',
    props: {
      content: {
        type: String,
        required: true,
        default: ''
      },
      highlight: {
        type: [String, RegExp],
        default: ''
      },
      highlightClass: {
        type: String,
        default: ''
      },
      antiXss: {
        type: Boolean,
        default: true
      },
      matcheWordBoundary: {
        type: Boolean,
        default: false
      },
      caseSensitive: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      genHTML() {
        const {
          antiXss,
          content,
          highlight,
          matcheWordBoundary,
          highlightClass,
          caseSensitive
        } = this;

        const isString = typeof (highlight) === 'string' && content;
        const isRegExp = highlight instanceof RegExp && content;

        if (isString || isRegExp) {
          let reg;

          if (isString) {
            if (highlight.trim() === '') {
              return antiXss ? xss(content) : content;
            }
            reg = new RegExp(`${matcheWordBoundary ? '\\b' : ''}${pregQuote(this.highlight)}${matcheWordBoundary ? '\\b' : ''}`, caseSensitive ? 'g' : 'gi');
          } else {
            reg = highlight;
          }

          if (!antiXss) {
            const regTag = /<\s*[^>]*>(.*?)<\s*\/[^>]*\s*>|<\s*[^>]*\/>/gi;
            let tagNode = [];
            let index = 0;
            return content.replace(regTag, (match) => {
              tagNode.push(match);
              return '☃☃';
            }).replace(reg, (matches) => {
              if (matches) {
                return `<span class="${highlightClass ? highlightClass : 'highlight'}">${(matches)}</span>`;
              }
              return matches;
            }).replace(/☃☃/g, () => {
              return tagNode[index++];
            });
          } else {
            const s = [];
            let contentByHTML = xss(content.replace(reg, (matches) => {
              if (matches) {
                const mark = `☃☃${matches}☃☃`;
                s.push(mark);
                return mark;
              }
              return matches;
            }));
            for (let i = 0; i < s.length; i++) {
              contentByHTML = contentByHTML.replace(xss(s[i]), (matches) => {
                if (matches) {
                  return `<span class="${highlightClass ? highlightClass : 'highlight'}">${matches.substring(2, matches.length - 2)}</span>`;
                }
                return matches;
              });
            }
            return contentByHTML;
          }
        }

        return content;
      }
    }
  };
</script>

<style lang="scss">
@import "../../scss/common/var";

.highlight {
  color: $--error-text-color;
  font-weight: bolder;
}
</style>
